const messages = {
  "label.login": "Login",
  "label.logout": "Logout",
  "label.createAccount": "Create account",
  "label.register": "Register",
  "label.name": "Name",
  "label.email": "Email",
  "label.password": "Password",
  "label.yes": "Yes",
  "label.no": "No",

  "label.layers": "Layers",
  "label.files": "Files",
  "label.projects": "Projects",
  "label.image": "Image",
  "label.text": "Text",
  "label.loading": "Loading...",
  "label.save": "Save",
  "label.saveAs": "Save as",
  "label.cancel": "Cancel",
  "label.title": "Title",
  "label.required": "Required",
  "label.frontSide": "Front",
  "label.backSide": "Back",
  "label.select": "Select",
  "label.create": "Create",
  "label.delete": "Delete",
  "label.selectModel": "Select model",

  "label.product": "Product",
  "label.object": "Object",
  "label.catalog": "Catalog",
  "label.createOwn": "Create your own",
  "label.color": "Color",
  "label.price": "Price",
  "label.size": "Size",
  "label.quantity": "Quantity",
  "label.total": "Total",
  "label.order": "Order",

  "label.phone": "Phone number",
  "label.send": "Send",

  "label.centerVertically": "Center vertically",
  "label.centerHorizontally": "Center horizontally",
  "label.flipHorizontally": "Flip horizontally",
  "label.flipVertically": "Flip vertically",
  "label.layerUp": "Layer up",
  "label.layerDown": "Layer down",
  "label.rotate": "Rotate",
  "label.fontStyle": "Font style",
  "label.fontFamily": "Font family",
  "label.byAgreement": "By agreement",

  "text.loadingAppState": "Loading app state",
  "text.selectObjectForCustomization":
    "Select an object to edit its parameters",
  "text.loginForProjects": "To save/load a project you need to",
  "text.notSavedProjects": "You don't have any saved projects yet",
  "text.confirmDelete": "Do you confirm deletion?",
  "text.projectName": "Project name",
  "text.designName": "Design name",
  "text.applicationAccepted": "Application accepted",
  "text.thanksApplicationAccepted":
    "Thank you, your application has been accepted!",
  "text.weWillContactYou": "We will contact you shortly.",
  "text.orderBeingProcessed":
    "Please wait while your order is being processed.",
  "text.canTakeSometime": "It can take some time.",
  "text.successfullyCreated": "Successfully created",
  "text.successfullyDeleted": "Successfully deleted",
  "text.successfullyUpdated": "Successfully updated",
  "text.successfullyloggedIn": "You are successfully logged in",

  "text.error.emptyName": "The name cannot be empty",
  "text.error.emptyTitle": "The title cannot be empty",
  "text.error.emptyPhone": "Fill in your phone number",
  "text.error.invalidEmail": "Invalid email",
  "text.error.shortPassword": "The password must contain at least 8 characters",
  "text.error.cantUploadFile": "Failed to upload file to server",
  "text.error.errorOccurred": "An error has occurred. Please try again later.",
  "text.error.invalidEmailOrPassword": "Invalid email or password",
  "text.error.emailAlreadyUsed": "A user with this email already exists",

  xxx: "yyy",
};

export default messages;
